export enum IconsGlobal {
  infoBlue = 'https://munily-public-cdn.s3.amazonaws.com/general/infoBlue.png',
  checkgray = 'https://munily-public-cdn.s3.amazonaws.com/general/checkGray.png',
  checkOrange = 'https://munily-public-cdn.s3.amazonaws.com/general/checkOrange.png',
  editGray = 'https://munily-public-cdn.s3.amazonaws.com/general/editGray.png',
  cancelGray = 'https://munily-public-cdn.s3.amazonaws.com/general/cancelGray.png',
  editDark = 'https://munily-public-cdn.s3.amazonaws.com/general/editDark.png',
  closeGray = 'https://munily-public-cdn.s3.amazonaws.com/general/closeGray.png',
  editV2Gray = 'https://munily-public-cdn.s3.amazonaws.com/general/respond.svg',
  download = 'https://munily-public-cdn.s3.amazonaws.com/onboarding/dashboard/icons/Icons_download.png',
  downloadBlue = 'https://munily-public-cdn.s3.amazonaws.com/shared/dashboard/Icon_file_download.svg'
}
